module.exports = __webpack_public_path__ + "static/img/secondarywuda.2d278aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ggw_img/secondarywuda.jpg
// module id = WX1F
// module chunks = 46